var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#374856",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,117.333C511.929,52.561,459.439,0.071,394.667,0H117.333C52.561,0.071,0.071,52.561,0,117.333v21.333   c0.008,19.49,7.669,38.198,21.333,52.096v203.904C21.404,459.439,73.895,511.929,138.667,512h234.667   c64.772-0.071,117.263-52.561,117.333-117.333V190.763c13.665-13.898,21.326-32.606,21.333-52.096V117.333z M64,117.333   C64,87.878,87.878,64,117.333,64h277.333C424.122,64,448,87.878,448,117.333v21.333c0,5.891-4.776,10.667-10.667,10.667H74.667   c-5.891,0-10.667-4.776-10.667-10.667V117.333z M426.667,394.667c0,29.455-23.878,53.333-53.333,53.333H138.667   c-29.455,0-53.333-23.878-53.333-53.333V213.333h341.333V394.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.667,256h106.667c17.673,0,32,14.327,32,32l0,0c0,17.673-14.327,32-32,32H202.667c-17.673,0-32-14.327-32-32l0,0   C170.667,270.327,184.994,256,202.667,256z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.3702d12c628f6e32f04808e8167182d1.svg";
export { ForwardRef as ReactComponent };